export default "__VITE_ASSET__ZfaedFyT__"